import GeneralView from '~/generalView';
import Handlebars from 'handlebars';
import toastr from 'toastr';
import EventHub from '~/eventHub';
import multiappbus_template from '~/templates/multiappbus.handlebars';
import getReportSuperCategoryService from '~/services/reportCategoryService';
var MultiAppBusView = GeneralView.View.extend({
	tagName: "div",
	className: 'User',
	busIcon: null,
	initialize: function () {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},

	events: {
		'change #upload' : 'uploadFile',
		'click .discardicon' : 'discardfile',
		'click #addemail' : 'addEmail',
		'click #delemail' : 'delEmail',
		'click #addsubcat' : 'addSubCat',
		'click #delsubcat' : 'delSubCat',
		'click #create-bussiness' : 'createBussiness',
	},
	
    render: function () {
		this.attachEvents();
		return this;
	},
	
	attachEvents: function() {
		var handlebarsTemplate = Handlebars.template(multiappbus_template);
		this.$el.html(handlebarsTemplate());
		this.$el.find('.businessloader').hide();
		this.translate();
	},

	uploadFile: function(e){
		var that = this;
		var reader = new FileReader();
		var namelenght = e.target.files[0].name.length;
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var name = 'FileCategory'+extension;
		$('#filenamef').fadeIn();
		$('#filenamef').empty();
		$('#filenamef').append("<div class='pull-left action remove-report discardicon' id='"+name+"' title='Descartar archivo'> "+ name +"</div><br><div class='separator2></div>");
		$(".discardicon").hover(function(){
			$(this).css("color", "#2F4F4F ");
			$(this).css("cursor", "pointer");
		}, function(){
			$(this).css("color", "inherit");
		});
		this.previewImage(e.target.files[0]);
		reader.onload = function (e) {
			var byteArray = new Uint8Array(e.target.result);
			var output = new Array(byteArray.length);
			var i = 0;
			var n = output.length;
			while (i < n) {
				output[i] = byteArray[i];
				i++;
			}
			var parseFile = new Parse.File(name, output);
			that.busIcon = parseFile;
		};
		reader.readAsArrayBuffer(e.target.files[0]);
	},

	previewImage: function(e){
		var reader = new FileReader();
		reader.onload = function (e) {
			$('#imageFile').fadeIn();
			$('#imageFile').empty();
			$('#imageFile').append('<img id="viewIcon" src="'+e.target.result+'">');
		};
		reader.readAsDataURL(e);
	},

	discardfile: function(e){
		e.currentTarget.remove();
		$('#imageFile').empty();
		$('#imageFile').fadeOut();
		$('#filenamef').empty();
		$('#filenamef').fadeOut();
		this.busIcon = null;
		$('#upload').val('');
	},

	addEmail: function(e){
		var emails = $('.user-email');
		$('#editor-field-emails').append("<input  type='email' class='form-control user-email' id='input-email"+ emails.length +"' value=''>");
		$('#delemail')[0].disabled = false;
	},

	delEmail: function(e){
		var emails = $('.user-email');
		if(emails.length > 1){
			$('.user-email')[emails.length-1].remove();
			$('#addemail')[0].disabled = false;
			if(emails.length == 2){
				e.currentTarget.disabled = true;
			}
		}
	},

	addSubCat: function(e){
		var subcat = $('.subcat-name');
		$('#editor-field-bussubcats').append("<input  type='text' class='form-control subcat-name' id='input-bussubcat"+ subcat.length +"' value=''>");
		$('#delsubcat')[0].disabled = false;
	},

	delSubCat: function(e){
		var subcat = $('.subcat-name');
		if(subcat.length > 1){
			$('.subcat-name')[subcat.length-1].remove();
			$('#addsubcat')[0].disabled = false;
			if(subcat.length == 2){
				e.currentTarget.disabled = true;
			}
		}
	},

	clearBussiness: function(){
		$('.discardicon').remove();
		$('#imageFile').empty();
		$('#imageFile').fadeOut();
		$('#filenamef').empty();
		$('#filenamef').fadeOut();
		this.busIcon = null;
		$('#upload').val('');
		$('#inputbusnamecat').val('');
		var inputEmails = $('.user-email');
		for(var i = inputEmails.length-1; i >= 0; --i){
			$('#input-email'+i).val('');
			if(i != 0){
				$('#input-email'+i).remove();
			}
		}
		$('#addemail')[0].disabled = false;
		$('#delemail')[0].disabled = true;
		var inputSubCat = $('.subcat-name');
		for(var i = inputSubCat.length-1; i >= 0; --i){
			$('#input-bussubcat'+i).val('');
			if(i != 0){
				$('#input-bussubcat'+i).remove();
			}
		}
		$('#addsubcat')[0].disabled = false;
		$('#delsubcat')[0].disabled = true;
		$('#create-bussiness')[0].disabled = false;
	},

	createBussiness: function(){
		var that = this;
		var busNameCat = $('#inputbusnamecat').val();
		var busIcon = this.busIcon;
		var emails = [];
		var inputEmails = $('.user-email');
		for(var i = 0; i < inputEmails.length; ++i){
			var temp = $('#input-email'+i).val();
			if(temp != ''){
				emails.push(temp);
			}
		}
		var subcats = [];
		var inputSubCat = $('.subcat-name');
		for(var i = 0; i < inputSubCat.length; ++i){
			var temp = $('#input-bussubcat'+i).val();
			if(temp != ''){
				subcats.push(temp);
			}
		}
		if(busNameCat != '' && busIcon != null && emails.length > 0 && subcats.length > 0){
			$('#create-bussiness')[0].disabled = true;
			window.spinnerDialog.show();
			Parse.Cloud.run("CreateBussiness", { 'busNameCat': busNameCat, 'emails': emails, 'subcats': subcats, 'userId': Parse.User.current().id }).then(function(result) {
				getReportSuperCategoryService().updateCategory(result.id, result.name, result.prefijo, busIcon);
				window.spinnerDialog.hide();
				that.clearBussiness();
				toastr.success('Empresa creada', "Operación realizada");
			},
			function(error){
				window.spinnerDialog.hide();
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'], 'Error');
					break;
					default:
						toastr.error('Error al crear la empresa', 'Error');
					break;
				}
			});
		}
		else {
			toastr.error('Por favor llenar todos los campos para crear una empresa', "Error");
		}
	},
});
export default MultiAppBusView;
